/**
 * Rest configuration
 *
 * @author Mamontov Andrey, 08/2019
 */

export class RestConfig {

  // rest url
  public static readonly REST_URL = '/api/v2';



  /**
   * System
   */
  public static readonly AUTH = '/users/login';

  /**
   * Document upload section
   */
  public static readonly DOCUMENTS = '/documents';
  public static readonly DOCUMENTS_FILES_UPLOAD = '/documents/files/upload';
  // public static readonly GET_DOCUMENTS_FILES = '/documents/files/'; // {id}


  /**
   * News section
   */
  public static readonly NEWS = '/news';
  public static readonly GET_ALL_NEWS = '/news_all';

  /**
   * Users section
   */
  public static readonly USERS = '/users';
  // public static readonly GET_ALL_NEWS = '/news_all';

  /**
   * Jobs section
   */
  public static readonly JOBS = '/jobs';
  // public static readonly GET_ALL_NEWS = '/news_all';

  /**
   * Reception section
   */
  public static readonly RECEPTION = '/reception';

  /**
   * Dictionaries section
   */
  public static readonly DICTIONARIES_VP = '/dictionaries/vp';
  public static readonly DICTIONARIES_VP_ACTIVE = '/dictionaries/vp_active';
  public static readonly DICTIONARIES_VP_ACTIVE_PAGEABLE = '/dictionaries/vp_active_pageable';
  public static readonly DICTIONARIES_MEMBERS = '/dictionaries/members';
  public static readonly DICTIONARIES_MEMBERS_ACTIVE = '/dictionaries/members_active';
  public static readonly DICTIONARIES_MEMBERS_TOTAL = '/dictionaries/members_total';
  public static readonly DICTIONARIES_LEADERS = '/dictionaries/leaders';
  public static readonly DICTIONARIES_COMPLAINTS_THEMES = '/dictionaries/complaints/themes';
  public static readonly DICTIONARIES_COMPLAINTS_REGIONS = '/dictionaries/complaints/regions';

  // base dictionaries
  public static readonly DICTIONARIES_BASE = '/dictionaries/';

  /**
   * Vpo section
   */
  public static readonly VPO = '/vpo';
  public static readonly GET_VPO_ACTIVE = '/vpo_active';

  /**
   * Roles section
   */
  public static readonly ROLES = '/roles';

  /**
   * Templates
   */
  public static readonly TEMPLATE = '/templates';

  /**
   * Structure section (site)
   */
  public static readonly STRUCTURE = '/structures';

  /**
   * Faq section
   */
  public static readonly FAQ = '/faq';

  /**
   * Memory book
   */
  public static readonly MEMORY_BOOK = '/memory_book';

  /**
   * Static files section
   */
  public static readonly GET_ONE_FILE = '/files/getOne/'; // {filename}

  public static readonly GET_EPP_FILE = '/files/download_epp'; // {filename}

  public static readonly GET_ONE_REGISTER_FILE = '/files/getRegisterOne/'; // {filename}

}
